import React from "react";
import { Route } from "react-router-dom";
import { Helmet } from "react-helmet";

type Props = {
  title: string;
  exact: boolean;
  path: any;
  component: React.FC;
};

const Page: React.FC<Props> = ({ title, exact, path, component }) => {
  return (
    <>
      <Helmet>
        <title>{title || "Pixlip"}</title>
      </Helmet>
      <Route exact={exact} path={path} component={component} />
    </>
  );
};

export default Page;
